import Immutable from 'immutable';
import store from 'store2';
import { push } from 'react-router-redux';

import { ORGANIZATION_ID_HEADER } from './organization';

const LOAD = 'auth/LOAD';
const LOAD_SUCCESS = 'auth/LOAD_SUCCESS';
const LOAD_FAIL = 'auth/LOAD_FAIL';

const SHOPIFY_UPDATE_SUCCESS = 'auth/SHOPIFY_UPDATE_SUCCESS';

const LOADUSERDETAIL = 'auth/LOADUSERDETAIL';
const LOADUSERDETAIL_SUCCESS = 'auth/LOADUSERDETAIL_SUCCESS';
const LOADUSERDETAIL_FAIL = 'auth/LOADUSERDETAIL_FAIL';

const LOAD_COMPANY_INFO = 'auth/LOAD_COMPANY_INFO';
const LOAD_COMPANY_INFO_SUCCESS = 'auth/LOAD_COMPANY_INFO_SUCCESS';
const LOAD_COMPANY_INFO_FAIL = 'auth/LOADUSERDETAIL_FAIL';

const LOGIN = 'auth/LOGIN';
const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
const LOGIN_FAIL = 'auth/LOGIN_FAIL';

const SIGNUP = 'auth/SIGNUP';
const SIGNUP_SUCCESS = 'auth/SIGNUP_SUCCESS';
const SIGNUP_FAIL = 'auth/SIGNUP_FAIL';

const SPECIAL_SIGNUP = 'auth/SPECIAL_SIGNUP';
const SPECIAL_SIGNUP_SUCCESS = 'auth/SPECIAL_SIGNUP_SUCCESS';
const SPECIAL_SIGNUP_FAIL = 'auth/SPECIAL_SIGNUP_FAIL';

const CHECK_SIGNUP = 'auth/CHECK_SIGNUP';
const CHECK_SIGNUP_SUCCESS = 'auth/CHECK_SIGNUP_SUCCESS';
const CHECK_SIGNUP_FAIL = 'auth/CHECK_SIGNUP_FAIL';

const FORGOTPASSWORD = 'auth/FORGOTPASSWORD';
const FORGOTPASSWORD_SUCCESS = 'auth/FORGOTPASSWORD_SUCCESS';
const FORGOTPASSWORD_FAIL = 'auth/FORGOTPASSWORD_FAIL';

const RESETPASSWORD = 'auth/RESETPASSWORD';
const RESETPASSWORD_SUCCESS = 'auth/RESETPASSWORD_SUCCESS';
const RESETPASSWORD_FAIL = 'auth/RESETPASSWORD_FAIL';

const UPDATEEMAIL_SUCCESS = 'auth/UPDATEEMAIL_SUCCESS';
const UPDATEEMAIL_FAIL = 'auth/UPDATEEMAIL_FAIL';

const LOAD_USERS = 'auth/LOAD_USERS';
const LOAD_USERS_SUCCESS = 'auth/LOAD_USERS_SUCCESS';
const LOAD_USERS_FAIL = 'auth/LOAD_USERS_FAIL';

const SAVE_USER = 'auth/SAVE_USER';
const SAVE_USER_SUCCESS = 'auth/SAVE_USER_SUCCESS';
const SAVE_USER_FAIL = 'auth/SAVE_USER_FAIL';

const IMPERSONATE = 'auth/IMPERSONATE';
const IMPERSONATE_SUCCESS = 'auth/IMPERSONATE_SUCCESS';
const IMPERSONATE_FAIL = 'auth/IMPERSONATE_FAIL';

const END_IMPERSONATION = 'auth/END_IMPERSONATION';
const END_IMPERSONATION_SUCCESS = 'auth/END_IMPERSONATION_SUCCESS';
const END_IMPERSONATION_FAIL = 'auth/END_IMPERSONATION_FAIL';

const LOGOUT = 'auth/LOGOUT';

const FLUSH = 'auth/FLUSH';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,

  isLogin: false,
  loginErr: null,

  user: null,

  isImpersonated: false,
  old_user: {
    authToken: '',
    user: null
  },
  clientCount: 0,
  clients: [],

  loading: false,
  signupError: null,
  signup: null,
  // signupInfo persists some of the data that was used during signup so that we can make decisions off of it(like redirects)
  signupInfo: null,

  budgetTypes: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('user', action.user);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('user', null);

    case SHOPIFY_UPDATE_SUCCESS:
      return state
        .set('isLoad', false)
        .set('user', action.user);

    case LOADUSERDETAIL:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOADUSERDETAIL_SUCCESS:
      return state
        .set('isLoad', false)
        .set('user', action.user);

    case LOADUSERDETAIL_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('user', null);

    case LOAD_COMPANY_INFO:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_COMPANY_INFO_SUCCESS:
      return state
        .set('isLoad', false)
        .set('budgetTypes', action.budgetTypes);

    case LOAD_COMPANY_INFO_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('budgetTypes', null);

    case LOAD_USERS:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_USERS_SUCCESS:
      return state
        .set('isLoad', false)
        .set('clients', action.result.rows)
        .set('clientCount', action.result.count);

    case LOAD_USERS_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('clients', []);

    case SAVE_USER:
      return state
        .set('isLoad', true)
        .set('saveUserErr', null);

    case SAVE_USER_SUCCESS:
      return state
        .set('isLoad', false);

    case SAVE_USER_FAIL:
      return state
        .set('isLoad', false)
        .set('saveUserErr', action.error);

    case LOGIN:
      return state
        .set('isLogin', true)
        .set('loginErr', null);

    case LOGIN_SUCCESS:
      return state
        .set('isLogin', false)
        .set('user', action.user);

    case LOGIN_FAIL:
      return state
        .set('isLogin', false)
        .set('loginErr', action.error)
        .set('user', null);

    case FORGOTPASSWORD:
      return state
        .set('loading', true)
        .set('forgotPasswordErr', null);

    case FORGOTPASSWORD_SUCCESS:
      return state
        .set('loading', false)
        .set('forgotPasswordErr', null);

    case FORGOTPASSWORD_FAIL:
      return state
        .set('loading', false)
        .set('forgotPasswordErr', action.error);

    case RESETPASSWORD:
      return state
        .set('loading', true)
        .set('resetPasswordErr', null)
        .set('resetUser', null);

    case RESETPASSWORD_SUCCESS:
      return state
        .set('loading', false)
        .set('resetPasswordErr', null)
        .set('resetUser', action.resetUser);

    case RESETPASSWORD_FAIL:
      return state
        .set('loading', false)
        .set('resetPasswordErr', action.error)
        .set('resetUser', null);

    case UPDATEEMAIL_SUCCESS:
      return state
        .set('loading', false)
        .set('user', action.user);

    case UPDATEEMAIL_FAIL:
        return state
          .set('loading', false);

    case SIGNUP:
      return state
        .set('loading', true)
        .set('signupError', null);

    case SIGNUP_SUCCESS:
      return state
        .set('loading', false)
        .set('signupError', null)
        .set('signupInfo', action.signupInfo);

    case SIGNUP_FAIL:
      return state
        .set('loading', false)
        .set('signupError', action.error)
        .set('signupInfo', null);

    case SPECIAL_SIGNUP:
      return state
        .set('loading', true)
        .set('signupError', null);

    case SPECIAL_SIGNUP_SUCCESS:
      return state
        .set('loading', false)
        .set('signupError', null)
        .set('user', action.user);

    case SPECIAL_SIGNUP_FAIL:
      return state
        .set('loading', false)
        .set('signupError', action.error)
        .set('user', null);

    case CHECK_SIGNUP:
      return state
        .set('emailloading', true)
        .set('signupError', null);

    case CHECK_SIGNUP_SUCCESS:
      return state
        .set('emailloading', false)
        .set('signup', action.signup)
        .set('signupError', null);

    case CHECK_SIGNUP_FAIL:
      return state
        .set('emailloading', false)
        .set('signupError', action.error);

    case IMPERSONATE:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case IMPERSONATE_SUCCESS:
      return state
        .set('isLoad', false)
        .set('isImpersonated', true)
        .set('old_user', action.old_user)
        .set('user', action.result);

    case IMPERSONATE_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr',  action.error);

    case END_IMPERSONATION:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case END_IMPERSONATION_SUCCESS:
      return state
        .set('isLoad', false)
        .set('isImpersonated', false)
        .set('user', action.result);

    case END_IMPERSONATION_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error);

    case LOGOUT:
    case FLUSH: {
      return initialState;
    }

    default:
      return state;
  }
}

export const load = (forced, shopifyToken = null) => async (dispatch, getState, api) => {
  // calling api is necessary if there is shopify token
  if(!shopifyToken) {
    // dont call api if user data is in state
    const user = getState().get('auth').get('user');
    if (user && !forced) {
      return;
    }
  }
  dispatch({ type: LOAD });

  try {
    const res = await api.get('/sessions');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, error: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS, user: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, error });
  }
};

export const updateUserWithShopifyToken = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/account/shopify', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, error: res.message });
      return;
    }

    const user = getState().get('auth').get('user');
    user.isShopifyUser = true;
    user.shopifyStore = data.shopifyStore;

    dispatch({ type: SHOPIFY_UPDATE_SUCCESS, user: user });
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const userDetail = (reload) => async (dispatch, getState, api) => {
  // dont call api if user data is in state
  const user = getState().get('auth').get('user');
  if (user && !reload) {
    return;
  }

  dispatch({ type: LOADUSERDETAIL });

  try {
    const res = await api.get('/sessions');
    if (res.message) {
      dispatch({ type: LOADUSERDETAIL_FAIL, error: res.message });
      return;
    }
    dispatch({ type: LOADUSERDETAIL_SUCCESS, user: res });
  } catch (error) {
    dispatch({ type: LOADUSERDETAIL_FAIL, error });
  }
};

export const loadCompanyInfo = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_COMPANY_INFO });

  try {
    const response = await api.get('/company-info');

    if (response.message) {
      dispatch({ type: LOAD_COMPANY_INFO_FAIL, error: response.message });
      return;
    }

    dispatch({ type: LOAD_COMPANY_INFO_SUCCESS, budgetTypes: response });
  } catch (error) {
    dispatch({ type: LOAD_COMPANY_INFO_FAIL, error });
  }
};

export const login = (username, password) => async (dispatch, getState, api) => {
  dispatch({ type: LOGIN });
  try {
    const res = await api.post('/sessions?jwt=1', { data: { username, password } });
    // set authToken to local storage
    store('authToken', res.accessToken);
    dispatch({ type: LOGIN_SUCCESS, user: res });
    window.location.reload();
  } catch (err) {
    dispatch({ type: LOGIN_FAIL, error: err.message });
  }
};

export const getAllUsers = (page = 1, params = {}) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_USERS });
  try {
    const result = await api.get(`/user/all/${page}`, { params });
    if (result.message) {
      dispatch({ type: LOAD_USERS_FAIL, error: result.message });
      return;
    }

    dispatch({ type: LOAD_USERS_SUCCESS, result });
  } catch (error) {
    dispatch({ type: LOAD_USERS_FAIL, error });
  }
};

export const saveUser = user => async (dispatch, getState, api) => {
  dispatch({ type: SAVE_USER });
  try {
    const payload = {
      planId: user.planId,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phoneNumber: user.phoneNumber,
    };

    const result = await api.put(`/user/${user.id}/admin-update`, { data: payload });
    if (result.message) {
      dispatch({ type: SAVE_USER_FAIL, error: result.message });
      return;
    }

    dispatch({ type: SAVE_USER_SUCCESS, result });
  } catch(err) {
    dispatch({ type: SAVE_USER_FAIL, error: err.message });
  }
};

export const impersonate = (username) => async (dispatch, getState, api) => {
  dispatch({ type: IMPERSONATE });
  try {
    const result = await api.post('/sessions/impersonate?jwt=1', { data: { username } })
    if (!result) {
      dispatch({ type: IMPERSONATE_FAIL, error: result.Message });
      return;
    }
    // keep old user
    const old_user = {
      authToken: store('authToken'),
      user: getState().get('auth').get('user')
    }

    // store new token
    store('authToken', result.accessToken);
    dispatch({ type: IMPERSONATE_SUCCESS, old_user, result: result.user });
    dispatch(push('/campaign'));
  } catch (err) {
    dispatch({ type: IMPERSONATE_FAIL, error: err.message });
  }
}

export const endImpersonation = () => (dispatch, getState, api) => {
  try {
    dispatch({ type: END_IMPERSONATION });
    const old_user = getState().get('auth').get('old_user');

    store('authToken', old_user.authToken);
    dispatch({ type: END_IMPERSONATION_SUCCESS, result: old_user.user });
    dispatch(push('/clients'));
  } catch (e) {
    dispatch({ type: END_IMPERSONATION_FAIL, error: e });
    throw e;
  }
};

export const logout = () => (dispatch, getState, api) => {
  store.remove('authToken');
  store.remove(ORGANIZATION_ID_HEADER);
  dispatch({ type: LOGOUT });
  dispatch({ type: 'FLUSH' });
  dispatch(push('/'));
};

export const forgotPassword = (email) => async (dispatch, getState, api) => {
  dispatch({ type: FORGOTPASSWORD });
  try {
    const res = await api.post('/account/forgotPassword', { data: { email } });
    dispatch({ type: FORGOTPASSWORD_SUCCESS, user: res });
  } catch (err) {
    dispatch({ type: FORGOTPASSWORD_FAIL, error: err.message });
  }
};

export const resetPassword = (token) => async (dispatch, getState, api) => {
  dispatch({ type: RESETPASSWORD });
  try {
    const res = await api.get('/account/resetPassword/'+ token );
    dispatch({ type: RESETPASSWORD_SUCCESS, resetUser: res });
  } catch (err) {
    dispatch({ type: RESETPASSWORD_FAIL, error: err.message });
  }
};

export const updateUserPass = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/account/resetPassword', { data });
    dispatch({ type: LOAD_SUCCESS });
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const updateEmailAddress = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/account/email', { data });
    if(res && !res.isError) {
      const user = getState().get('auth').get('user');
      dispatch({ type: UPDATEEMAIL_SUCCESS, user: Object.assign({}, user, { email: data.email } ) });
    }
    return res;
  } catch(err) {
    dispatch({ type: UPDATEEMAIL_FAIL });
  }
}




export const signup = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: SIGNUP });

  try {
    const res = await api.post('/account', { data: obj });

    if(res.message)
      return dispatch({ type: SIGNUP_FAIL, error: res.message });

    const signupInfo = {
      isFromInvite: !!obj.inviteToken,
      planId: obj.planId
    };

    // set authToken to local storage
    store('authToken', res.accessToken);
    // we used to dispatch the `user` in this action however that conflicted with LOAD_SUCCESS and made it hard to
    // control when we redirect users to /campaigns - so now we dispatch `signupInfo` in SIGNUP_SUCCESS and `user`
    // in LOAD_SUCCESS
    dispatch({ type: SIGNUP_SUCCESS, signupInfo });
  } catch (err) {
    dispatch({ type: SIGNUP_FAIL, error: err.message });
  }
};

export const changeUserPass = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/account/changePassword', { data });
    //dispatch({ type: RESETPASSWORD_SUCCESS});
    return 'Success';
  } catch (err) {
    return 'Fail';
  }
};


export const special_signup = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: SPECIAL_SIGNUP });
  try {
    const res = await api.post('/account/special', { data: obj });
    if(res.message) {
      return dispatch({ type: SPECIAL_SIGNUP_FAIL, error: res.message });
    }
    store('authToken', res.accessToken);
    dispatch({ type: SPECIAL_SIGNUP_SUCCESS, user: res });
    dispatch(this.load(true));
  } catch (err) {
    dispatch({ type: SPECIAL_SIGNUP_FAIL, error: err.message });
  }
};

export const check_signup = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: CHECK_SIGNUP });
  try {
    const res = await api.post('/account/check', { data: { username: obj.username } });
    if(res.message) {
      return dispatch({ type: CHECK_SIGNUP_FAIL, error: res.message });
    }
    return dispatch({ type: CHECK_SIGNUP_SUCCESS, data: res, signup: obj });
  } catch (err) {
    dispatch({ type: CHECK_SIGNUP_FAIL, error: err.message });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/auth.js